module.exports = __webpack_public_path__ + "static/img/naver.dbc7e40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/naver.png
// module id = /93V
// module chunks = 1